module.exports = __webpack_public_path__ + "static/media/media_icon.455f6a10.svg";